// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/172.26.59.72+4873+css-loader@6.7.3_webpack@5.76.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/172.26.59.72+4873+css-loader@6.7.3_webpack@5.76.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bay-layout-content{background-color:var(--wk-color-white);border-radius:var(--wk-border-radius-sm)}.bay-layout-content:not(:only-child){margin-top:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
